import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Modal } from 'hljd'
import Api from '@api/xiao_xiong/dynamic'
import styles from './style.module.less'
import { getMerchantInfo } from '@util'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      hallList: []
    }
    this.getAllTags()
  }

  componentDidMount() {
    document.addEventListener('click', this.hideTags)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.hideTags)
  }

  showTags = e => {
    if (!this.state.hallList.length) {
      return Modal.warning({
        title:
          '请在商家电脑端-酒店管理-场地管理中设置宴会厅，审核通过后可以关联。'
      })
    }
    this.setState({ visible: true })
    e.nativeEvent.stopImmediatePropagation()
  }

  hideTags = () => {
    this.setState({ visible: false })
  }

  onSelect = id => {
    this.props.onChange(id)
    this.hideTags()
  }

  getAllTags = async () => {
    const merchant_id = getMerchantInfo().id
    const { success, data } = await Api.hotelHallList({ merchant_id })
    if (success) {
      this.setState({
        hallList: data.list || []
      })
    }
  }

  getSelectedTagName = () => {
    const { value } = this.props
    const { hallList } = this.state
    if (!value || !hallList.length) {
      return ''
    }
    const hall = hallList.find(({ id }) => id == value) || {}
    return hall.name
  }

  render() {
    const { visible, hallList } = this.state
    const selectedName = this.getSelectedTagName()
    return (
      <div className={styles.wrapper}>
        <div className={styles.title} onClick={this.showTags}>
          <i className={`iconfont icondingwei-xianxing`} />
          <span>{selectedName || '关联宴会厅'}</span>
        </div>
        <div
          className={styles.tags}
          style={{ display: visible ? 'block' : 'none' }}
          onClick={e => e.nativeEvent.stopImmediatePropagation()}
        >
          {hallList.map(hall => {
            const { id, name, bestTableNum, maxTableNum } = hall
            return (
              <span
                key={id}
                className={styles.tag}
                onClick={() => this.onSelect(id)}
              >
                {name}({bestTableNum}-{maxTableNum}桌)
              </span>
            )
          })}
        </div>
      </div>
    )
  }
}
